import { configureStore } from "@reduxjs/toolkit";
import dataReducer from "./dataSlice"; // Import the slice (our API data drawer)

export const store = configureStore({
  reducer: {
    data: dataReducer, // This tells Redux: "Store API data in the 'data' drawer"
  },
});

export default store;
